import { CS } from "../../../../base/utils/styler";

export const linkTdStyle: CS = {
    textAlign: 'left',
    fontSize: '16px',
    color: '#027bffcc',
    position: 'relative',

}

export const externalLinkStyle: CS = {
    position: 'absolute',
    left: '216px',
    top: '19px',
    opacity: '0.4',
    cursor: 'pointer',
    display: 'none',
    '&:hover': {
        opacity: '.8'
    }
}

export const editableStyle: CS = {
    minWidth: '50px',
    cursor: 'pointer',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    border: '1px solid transparent',
    padding: '5px',
    backgroundColor: 'white',
    zIndex: '0',
    marginLeft: '12px',
    height: '34px',
    borderRadius: '5px',
    maxWidth: '200px',
    display: 'inline-block',
    '&:hover': {
        borderColor: '#ccc',
    },
    '&:focus': {
        position: 'absolute',
        top: '10.5px',
        left: '1px',
        zIndex: 1,
        maxWidth: '630px',
        width: '630px',
        whiteSpace: 'normal',
        borderColor: '#aaa',
        outline: 'none'
    }
}